import { Injectable, inject } from '@angular/core';
import { SupabaseClient } from '@supabase/supabase-js';
import { UserService } from '../user-service/user.service';
import { SubCategory } from '@app/model/sub-category';
import { SUPABASE_CLIENT } from '../../providers/supabase.provider';

@Injectable({
  providedIn: 'root'
})
export class SubCategoryService {

  subCategory: SubCategory = new SubCategory('', '', '', '', '', false, false, []);
  subCategories: SubCategory[] = [];
  private supabaseClient: SupabaseClient;

  constructor(private userService: UserService) {
    this.supabaseClient = inject(SUPABASE_CLIENT);
  }

  async getAllSubCategory() {
    const res = await this.supabaseClient.from('sub_categories').select('*');
    return res;
  }

  async getThreeRandomSubCategoriesTitleByCategoryId(categoryId: string) {
    const res = await this.supabaseClient.from('sub_categories').select('title').eq('parent_category_id', categoryId).limit(3);
    return res;
  }

  async getSubCategoryById(subCategoryId: string) {
    const res = await this.supabaseClient.from('sub_categories').select('*').eq('id', subCategoryId);
    return res;
  }

  async getSubCategoriesByCategoryId(categoryId: string) {
    const res = await this.supabaseClient.from('sub_categories').select('*').eq('parent_category_id', categoryId);
    return res;
  }

  async getSubCategoriesByIds(subCategoryIds: string[]) {
    const res = await this.supabaseClient.from('sub_categories').select('*').in('id', subCategoryIds);
    return res;
  }

  async getActivateUsersIdBySubCategoryId(subCategoryId: string) {
    const res = await this.supabaseClient.from('sub_categories').select('activate_users').eq('id', subCategoryId);
    return res;
  }

  async getParentCategoryIdBySubCategoryId(subCategoryId: string) {
    const res = await this.supabaseClient.from('sub_categories').select('parent_category_id').eq('id', subCategoryId);
    return res;
  }

  async createSubCategory(subCategory: SubCategory) {
    const res = await this.supabaseClient.from('sub_categories').insert([
      {
        color: subCategory.color,
        title: subCategory.title,
        description: subCategory.description,
        parent_category_id: subCategory.parent_category_id,
        need_pro: subCategory.need_pro,
        activate_users: subCategory.activate_users,
      }
    ]);
    return res;
  }

  async updateSubCategory(subCategory: SubCategory) {
    const res = await this.supabaseClient.from('sub_categories').update({
      color: subCategory.color,
      title: subCategory.title,
      description: subCategory.description,
      need_pro: subCategory.need_pro,
      activate_users: subCategory.activate_users,
      is_available: subCategory.is_available,
      parent_category_id: subCategory.parent_category_id,
    }).eq('id', subCategory.id);
    return res;
  }

  async getAvailableSubCategories() {
    const userId = await this.userService.getUserId();
    const res = await this.getAllSubCategory();
    const subCategories: SubCategory[] = [];
    res?.data?.forEach((subCategory: any) => {
      if (subCategory.activate_users.includes(userId)) {
        subCategories.push(subCategory);
      }
    });
    return subCategories;
  }

  async getAvailableSubCategoriesByCategoryId(categoryId: string) {
    const userId = await this.userService.getUserId();
    const res = await this.getSubCategoriesByCategoryId(categoryId);
    const subCategories: SubCategory[] = [];
    res?.data?.forEach((subCategory: any) => {
      if (subCategory.activate_users.includes(userId)) {
        subCategories.push(subCategory);
      }
    });
    return subCategories;
  }

  async checkCategoryIsParentCategory(categoryId: string) {
    const res = await this.getAllSubCategory();
    if (res.error) throw res.error;
    let existChildSubCategory = false;
    for (const subCategory of res?.data || []) {
      if (subCategory.parent_category_id === categoryId) {
        existChildSubCategory = true;
        break;
      }
    }
    return existChildSubCategory;
  }

  async checkIsAvailableForPro(subCategoryId: any) {
    const userId = await this.userService.getUserId();
    const res = await this.getSubCategoryById(subCategoryId);
    if (res?.data?.[0].activate_users.includes(userId)) {
      return true;
    } else {
      return false;
    }
  }

  async addActivateUser(subCategoryId: any, userId: any) {
    const res = await this.getSubCategoryById(subCategoryId);
    if (res.error) throw res.error;
    const activateUsers = res?.data?.[0].activate_users;
    if (!activateUsers) throw new Error('找不到小類別授權資料');
    const updatedActivateUsers = [...new Set([...activateUsers, userId])];
    const { error } = await this.supabaseClient.from('sub_categories').update({
      activate_users: updatedActivateUsers,
    }).eq('id', subCategoryId);
    if (error) throw error;
  }

  async deleteSubCategory(subCategoryId: any) {
    return this.supabaseClient.from('sub_categories').delete().eq('id', subCategoryId);
  }
}
